<template>
  <q-card bordered flat>
    <div v-if="tag.post">
      <post :post="tag.post" />
      <q-card-actions
        v-if="tag.post.link"
        align="right"
        class="q-pt-none"
      >
        <q-btn
          size="sm"
          icon="fa fa-external-link-alt"
          label="View post"
          color="primary"
          flat dense no-caps
          :href="tag.post.link"
          target="_blank"
        />
      </q-card-actions>
    </div>
    <div v-else class="text-center text-grey-5 q-pa-md">
      Post unavailable
    </div>
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostTag } from '@/type';
import Post from '@/social/post/card/Post.vue';

export default defineComponent({
  components: {
    Post,
  },
  props: {
    tag: {
      type: Object as () => PostTag,
      required: true,
    },
  },
});
</script>
